import React from "react";
import DropDown from "components/DesignSystem/Dropdown/Dropdown";
import { OptionDropdown } from "components/icons/optionDropdown";
import {
  useToggleChannelFrozenMutation,
  useToggleChannelRepliedMutation,
} from "store/apis/chat";
import { useToast } from "hooks/useToast";

const MarkRepliedUnreplied = ({
  isFrozen,
  showDropdown,
  setShowDropdown,
  unreplied,
  channelId,
}: {
  showDropdown: boolean;
  setShowDropdown: (v: boolean) => void;
  unreplied?: boolean;
  channelId: string;
  isFrozen: boolean;
}) => {
  const { successToast } = useToast();
  const [toggleChannelRepliedStatus, { isLoading }] =
    useToggleChannelRepliedMutation();

  const [updateChannelFrozen, { isLoading: isLoadingFrozen }] =
    useToggleChannelFrozenMutation();

  const toggleChannelReply = async () => {
    try {
      if (channelId) {
        await toggleChannelRepliedStatus({
          channelId,
          channelNeedsReply: unreplied ? false : true,
        });
        successToast({
          title: "Channel update",
          message: `Channel marked as ${unreplied ? "replied" : "unreplied"}.`,
        });
      }
    } catch (e: any) {
      alert(e?.data?.error?.message);
    }
  };

  const copyChannelLink = async () => {
    const isTaxIncluded = window.location.pathname.includes("tax");
    const base = isTaxIncluded ? "tax" : "books";
    if (channelId) {
      const channelUrl = `${window.location.origin}/${base}/chat/${channelId}`;
      try {
        await navigator.clipboard.writeText(channelUrl);
        successToast({
          title: "Link copied",
          message: "Channel link copied to clipboard.",
        });
      } catch (err) {
        console.error("Failed to copy: ", err);
      }
    }
  };

  const toggleChannelFrozen = async () => {
    try {
      if (channelId) {
        await updateChannelFrozen({
          channelId,
        }).unwrap();
        successToast({
          title: "Channel update",
          message: `Channel marked as ${isFrozen ? "unfrozen" : "frozen"}.`,
        });
      }
    } catch (e: any) {
      alert(e?.data?.error?.message);
    }
  };

  return (
    <DropDown.Root onOpenChange={setShowDropdown} open={showDropdown}>
      <DropDown.Trigger asChild disabled={isLoading || isLoadingFrozen}>
        <div className="t-size-6 t-rounded hover:t-bg-purple-20 data-state-open:t-bg-purple-20 t-items-center t-justify-center t-flex">
          <OptionDropdown color="currentColor" />
        </div>
      </DropDown.Trigger>
      <DropDown.Portal>
        <DropDown.Content className="!t-min-w-24" sideOffset={8} align="start">
          <DropDown.Item onSelect={toggleChannelReply}>
            {unreplied ? "Mark as replied" : "Mark as unreplied"}
          </DropDown.Item>
          <DropDown.Item onSelect={toggleChannelFrozen}>
            {isFrozen ? "Unfreeze" : "Freeze"}
          </DropDown.Item>
          <div onClick={(e) => e.stopPropagation()}>
            <DropDown.Item onSelect={copyChannelLink}>
              Copy Channel Link
            </DropDown.Item>
          </div>
        </DropDown.Content>
      </DropDown.Portal>
    </DropDown.Root>
  );
};

export default MarkRepliedUnreplied;
